/**
 * LangServer 모듈 목록 조회 API
 */
import { langServerClient } from '@/shared/api/langserver/client';
import { createDemoModulesResponse, shouldUseDemoModules } from '@/shared/api/langserver/demo';

import type { ModulesResponse, ModuleTarget } from './types';

export const fetchModules = async (target: ModuleTarget = 'run', clientId: string): Promise<ModulesResponse> => {
  if (shouldUseDemoModules(target)) {
    return createDemoModulesResponse(target);
  }

  try {
    const response = await langServerClient.get<ModulesResponse>(`/${target}/api/v1/modules/${clientId}`);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch modules:', error);
    throw error;
  }
};
